import { DateTime } from "luxon";
import { UserStatus } from "./LoginResponseDto";

export class AgencyUserDto {
	agencyId: string;
	autoLogoutPeriodId?: string;
	autoLogoutPeriodStartDate?: string;
	bettingTimeoutId?: string;
	bettingTimeoutStartDate?: string;
	bIC: string;
	birthName: string;
	birthPlace: string;
	city: string;
	countryId: string | null;
	customerCardId: string;
	dateOfBirth: string;
	documentExpiration?: null | string;
	email: string;
	firstName: string;
	houseBox: string;
	houseNumber: string;
	iBAN: string;
	iPAddress: string;
	isAdminLock: boolean;
	isAgencyWideCashierEnabled?: boolean;
	isApproved: boolean;
	isLockedOut: boolean;
	isPep?: boolean;
	playerPromoSendingMode: PlayerPromoSendingMode;
	isValid: boolean;
	json: string;
	lastBettingReviewCheckDate?: DateTime;
	lastLoginDate: Date;
	lastName: string;
	lastPepCheckDate?: DateTime;
	mailVerificationStatus?: number;
	mobilePhone: string;
	nationality?: string;
	numericalId: number;
	passportId: string;
	payPin: string;
	personalIdentificator: string;
	pin: string;
	profession: string;
	regionId?: string;
	secondAddressReason: string;
	secondCity: string;
	secondCountryId?: string;
	secondHouseNumber: string;
	secondStreet: string;
	secondZipCode: string;
	cultureInfoName: string;
	shopId: string;
	street: string;
	telephoneNumber: string;
	titleId: string;
	userAccountLockDurationTypeId?: string;
	userAccountLockEndDate?: DateTime;
	userAccountLockExplanation: string;
	userAccountLockReasonTypeId?: string;
	userAccountLockStartDate?: DateTime;
	userAccountTypeId?: string;
	userId?: string;
	userMonitorStartDate?: DateTime;
	userMonitorTypeId: string;
	userName: string;
	validationDate?: DateTime;
	zipCode: string;
	insicStatus: UserStatus;
	occupationId: string;
	annualIncomeSpanId?: string;
	userRecheckDueDate: string | null;
	displayUserId?: string | null;
}

export enum PlayerPromoSendingMode {
	disabled,
	enabled,
	forbidden,
}
